import React from 'react'
import { useIntl } from 'react-intl'
import useMostPopulatedSearchExperienceFacets from '../hooks/useMostPopulatedSearchExperienceFacets'
import ExperiencesPageSearchCarousel from './ExperiencesPageSearchCarousel'
import { EXP_CATEGORY_GIFT_INSPIRATION } from 'constants/experience'
import { getListName } from 'analytics/enhanced-ecommerce'

interface Props {
  place: App.Place
}

function ExperiencesPageCollectionsCarousels(props: Props) {
  const intl = useIntl()
  const { place } = props
  const { collections, fetching } = useMostPopulatedSearchExperienceFacets(place)

  if (collections.length === 0 && !fetching) {
    return null
  }

  return (
    <>
      {collections.map(collection => (
        <ExperiencesPageSearchCarousel
          key={collection.collectionId}
          title={collection.theme}
          primaryPlace={place}
          filterMode="place"
          collections={[collection]}
          trackingListName={getListName('OfferList', 'EXPERIENCES', `Collections Carousel - ${collection.theme}`)}
        />
      ))}

      <ExperiencesPageSearchCarousel
        title={intl.formatMessage({
          id: 'fMLMDrQ9Ymrdc7cRma8P',
          defaultMessage: 'Perfect Gifts for Someone Special',
          description: 'Carousel heading for gift inspiration experiences on experiences landing page',
        })}
        primaryPlace={place}
        filterMode="place"
        parentCategoryCode={EXP_CATEGORY_GIFT_INSPIRATION}
        trackingListName={getListName('OfferList', 'EXPERIENCES', 'Collections Carousel - Perfect Gifts for Someone Special')}
      />
    </>
  )
}

export default ExperiencesPageCollectionsCarousels
